












import Vue from 'vue'
import { ItemTabElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'TabLinkEl',

  props: {
    templateItemData: {
      type: Object as () => ItemTabElInterface,
      required: true
    }
  }
})
